//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Modal as ModalSection, Button as MtButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material';
import React, { useCallback, useMemo, useState, useRef } from 'react';
import styled from 'styled-components';
//  -- Components ---------------------
import { PlusOutlined, EyeOutlined, EyeInvisibleOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, Col, Divider, Input, Modal, Row, Select, Tabs } from 'antd';
import Loading from 'components/Loading';
//  -- Constants ----------------------
import { filter, find, get, isEmpty, sortBy, uniqBy } from 'lodash';
//  -- Thunks -------------------------
import { Add } from '@mui/icons-material';
import { CanvasCourseModal } from 'components/admin/bookmaps/CanvasCourseModal';
import { ClasslinkCourseModal } from 'components/admin/bookmaps/ClasslinkCourseModal';
import { CleverCourseUpdate } from 'components/admin/bookmaps/CleverUpdateModal';
import { GooleCourseModal } from 'components/admin/bookmaps/GoogleCourseModal';
import { SchoologyUpdateModal } from 'components/admin/bookmaps/SchoologyUpdateModal';
import VocabAccessModal from 'components/admin/VocabPermission';
import BadgeButton from 'components/AdminBooks/BadgeButton';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGoogleCourseMapByDistrict } from 'store/booksUnits/selectors';
import { handleGetCanvasCourseByDist, handleGetClasslinkCourseByDist, handleGetCleverCourseByDist, handleListSchoologyCourcesByDistId } from 'store/booksUnits/thunks';
import { handleListLicences } from 'store/licences/thunks';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleGetArchiveOrganization, handleGetOrganization, handleUpdateOrganization } from "store/organizations/thunks";
import COLOR from 'utils/constants/color';
import DistrictPreviewModal from 'components/admin/Licenses/LicenseUtilizationView';
import { STANDARD_GRADE_LEVEL } from 'utils/config/reference';
import { apis } from 'utils/lib/apis';
import { formatStateNameForDisplay } from 'utils/lib/standardHelper';
const BORDERCOLOR = [
    "rgb(200,109,152)",
    "rgb(146,158,227)",
    "rgb(80,233,200)",
    "rgb(238,206,151)",
];
const INTEGRATION_KEYS = [
  ['cleverId',   'Clever'],
  ['classlinkid','Classlink'],
  ['canvas_id',  'Canvas'],
  ['schoolId',   'Schoology'],
]
const getOverusedLicenses = (allocated, used) => {
  const allocatedNum = parseInt(allocated || '0', 10) || 0;
  const usedNum = parseInt(used || '0', 10) || 0;
  return Math.max(usedNum - allocatedNum, 0);
};
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const StableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
//   @media (max-width: 992px) {
//     padding:24px 0px;
//   }
`;
const StableWrapperMain = styled.div`
`;

const OverViewContainer = styled.div`
display:flex;
flex-direction:column;
justify-content:flex-start;
margin-bottom:20px;
`;
const OverViewLabel = styled.span`
font-size: 12px;
font-weight: 600;
`;
const OverViewValue = styled.span`
font-size: 17px;
font-weight: 500;
cursor: pointer;
`;
const FilterContainer = styled.span`
  font-size:17px;
  font-weight:500;
  cursor:pointer;
`;

const ViewDemo = styled.span`
textAlign: "left";
color: ${(p) => (p.color)};
`;
const ProfileContainer = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    gap:10px;
`;

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;
const { TabPane } = Tabs;


const DistrictTable = ({
    districts,
    userloading,
    onTabsJump = () => null,
}) => {
    const showAlert = useAlert();
  	const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentOrg = useCurrentOrg();
    const [data, setData] = useState("");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [modal2Open, setModal2Open] = useState(false);
    const [filteredDistricts, setFilteredDistricts] = useState([]);
    const [integrationFilter, setIntegrationFilter] = useState([]);
    const [enableLoader, setEnableLoader] = useState(-1);
    const [selectedFilter, setSelectedFilter] = useState('all')
    const [alertForStatus, setAlertForStatus] = useState(false)
    const [DistrictToActive, setDistrictToActive] = useState({})
    const [DistrictStatus, setDistrictStatus] = useState('')
    const [ActiveLoader, setActiveLoader] = useState(-1);
    const [loader, setLoader] = useState(false);
    const is_schoology = !!data?.schoolId
    const is_canvas = !!data?.canvas_id
    const is_classlink = !!data?.classlinkid
    const is_clever = !!data?.cleverId
    const [loaderType, setLoaderType] = useState('')
    const [distBookMapData, setDistBookMapData] = useState({})
    const [distBGoogleookMapData, setDistGoogleBookMapData] = useState({})
    const [openModalType, setOpenModalType] = useState('')
    const googleClassRoomCourseMap = useGoogleCourseMapByDistrict()
    const [selectedOrg,setSelectedOrg] = useState({})
    const [activeTabKey, setActiveTabKey] = useState("1"); // Added state for active tab key
    const [searchText, setSearchText] = useState('')
    const [viewLicensusesDetail, setLicenseUsesView] = useState({
        open: false,
        orgId: null
    })
    const [showOverusedOnly, setShowOverusedOnly] = useState(false)
    const [standardStateModalOpen, setStandardStateModalOpen] = useState(false);
    const [selectedStandardStates, setSelectedStandardStates] = useState([]);
    const [savingStandardState, setSavingStandardState] = useState(false);
    const skipPageResetRef = useRef(false);

    useEffect(() => {
        dispatch(handleListLicences())
    }, [])
    useEffect(() => {
        if (selectedOrg?.id) {
            const has_google_course = find(googleClassRoomCourseMap, ["orgId", selectedOrg.id])
            if (has_google_course)
                setDistGoogleBookMapData(has_google_course)
        }
    }, [googleClassRoomCourseMap, selectedOrg])
    const fetchBooksMapping = async (data) =>{
        if (data?.schoolId) {
            setLoaderType('schoology')
            const district_book_map = await handleListSchoologyCourcesByDistId(data?.id, "district")
            if (district_book_map && district_book_map.success) {
                if (district_book_map.data && district_book_map.data.length > 0) {
                    setDistBookMapData(district_book_map.data[0])
                } else {
                    setDistBookMapData({ displayName: data.displayName, "schoolId": data?.schoolId, books: [], district_id: data.id, mapping_type: 'district' })
                }
            }
          setLoaderType('')
        }else if(data?.canvas_id){
            setLoaderType('canvas')
            const district_book_map = await handleGetCanvasCourseByDist(data?.id)
            if(district_book_map&&district_book_map.success){
              if(district_book_map.data&&district_book_map.data.length>0){
                  setDistBookMapData(district_book_map.data[0])
              }else{
                  setDistBookMapData({ displayName:data.displayName, "courseId":null, "canvas_id":data.canvas_id, "orgId":data.id, books:[] })
              }
             
            }
            setLoaderType('')
        }else if(data?.classlinkid){
            setLoaderType('classlink')
            const district_book_map = await handleGetClasslinkCourseByDist(data?.id)
            if(district_book_map&&district_book_map.success){
              if(district_book_map.data&&district_book_map.data.length>0){
                  setDistBookMapData(district_book_map.data[0])
              }else{
                  setDistBookMapData({ displayName:data.displayName, 
                    "courseId":null,
                    "classSourceId":data.classlinkid,
                    "districtId":data.id,
                    "tenantId":data.classlinkTenantId,
                     "orgId":data.id, books:[] })
              }
             
            }
            setLoaderType('')
        }else if(data?.cleverId){
            setLoaderType('clever')
            const district_book_map = await handleGetCleverCourseByDist(data?.id)
            if(district_book_map&&district_book_map.success){
              if(district_book_map.data&&district_book_map.data.length>0){
                  setDistBookMapData(district_book_map.data[0])
              }else{
                  setDistBookMapData({ displayName:data.displayName, "courseId":null, "cleverDistId":data.cleverId, "orgId":data.id, clever_course_id:null, books:[] })
              }
             
            }
            setLoaderType('')
            
        }
    }
  
    useEffect(()=>{
        if(integrationFilter.length > 0) {
            onFilterApply(selectedFilter)
        }
    },[integrationFilter,selectedFilter])

    const setFilterdDistrict = (dist) => {
        if (dist) {
            const cOrg = find(dist, d => d.id == get(currentOrg, "id"))
            if (cOrg) {
                const sortedDist = sortBy(filter(dist, d => d.id != get(currentOrg, "id")), ["displayName"])
                const res = [cOrg, ...sortedDist]
                // setFilteredDistricts(res)
                setIntegrationFilter(uniqBy(res,"id"))
            } else {
                // setFilteredDistricts(sortBy(dist, ["displayName"]))
                setIntegrationFilter(uniqBy(sortBy(dist, ["displayName"]),"id"))
            }

        } else {
            setIntegrationFilter([])
            // setFilteredDistricts([])
        }
    }
    useEffect(() => {
        setFilterdDistrict(districts)
    }, [districts])

    useEffect(() => { 
        if (!skipPageResetRef.current) {
            setPage(0)
        }
    }, [filteredDistricts])



    const filtData = useMemo(() => {
        let baseData = filteredDistricts
            .filter(d => d.active && d.typeId === "district")
            .filter(d =>
                !searchText ||
                d.displayName.toLowerCase().includes(searchText.toLowerCase())
            );
        if (showOverusedOnly) {
            baseData = baseData.filter(d => getOverusedLicenses(d?.licenses, d?.total_utilized) > 0);
        }
        if (currentOrg?.id) {
            return [...baseData].sort((a, b) => {
                if (a.id === currentOrg.id) return -1;
                if (b.id === currentOrg.id) return 1;
                return 0;
            });
        }
        return baseData;
    }, [filteredDistricts, searchText, currentOrg, showOverusedOnly]);

    const handleSearchDistrict = (event) => {
        setSearchText(event.target.value)
    };

    const handleChange = (value) => {
        setSearchText('');
        setSelectedFilter(value)    
    };
    const onFilterApply = (value) =>{
        switch (value) {
            case 'all':
                setFilteredDistricts(integrationFilter);
                break;
            case 'clever':
                const filterClever = filter(integrationFilter, obj => obj.cleverId)
                setFilteredDistricts(filterClever);
                break;
            case 'classlink':
                const filterClasslink = filter(integrationFilter, obj => obj.classlinkid || obj.classlinkTenantId)
                setFilteredDistricts(filterClasslink);
                break;
            case 'schoology':
                const filterSchoology = filter(integrationFilter, obj => obj.schoolId)
                setFilteredDistricts(filterSchoology);
                break;
            case 'canvas':
                const filterCanvas = filter(integrationFilter, obj => obj.canvas_id)
                setFilteredDistricts(filterCanvas);
                break;
            case 'google':
                const filter_Google = filter(integrationFilter, obj => find(googleClassRoomCourseMap,["orgId",obj.id]))
                setFilteredDistricts(filter_Google);
                break;
            default:
                break;
        }
    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
                console.log("setpage111122222")

        setPage(0);
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleCurrentOrgLoader = async (data, jumPage) => {
        if (!data?.active) return;
        setEnableLoader(data?.id)
        const has_google_course = find(googleClassRoomCourseMap, ["orgId", data.id])
        if (has_google_course) {
            setDistGoogleBookMapData(has_google_course)
        } else {
            setDistGoogleBookMapData({})
        }
        setSelectedOrg(data)
        fetchBooksMapping(data,jumPage === 'see_schools')
        setLoader(true);
        if (currentOrg?.id !== data?.id) {
            localStorage.setItem("lastActiveOrgAdmin", data?.id)
            await dispatch(handleGetOrganization(data?.id))
            setLoader(false);
        }
        else {
            setLoader(false);
        }
        if (jumPage === 'see_schools') {
            onTabsJump("see_schools", data)
        }
        if (jumPage === 'see_teachers') {
            onTabsJump("see_teachers", data)
        }
        if (jumPage === 'see_students') {
            onTabsJump("see_students", data)
        }
        // setLoader(false);
    }
    const addDistict = (value) => {
        const editData = {
            userData: data,
            isEdit: true
        }
        const addData = {
            userData: null,
            isEdit: false
        }
        if (value == 'edit') {
            navigate("/addDistrict", { state: editData });
        } else {
            navigate("/addDistrict", { state: addData });
        }
    }

    const handleActiveDistrict = async(id, active) => {
        const data = {
            active,
            id
        }
        setActiveLoader(id);
        const result = await dispatch(handleGetArchiveOrganization(data));
        if (result?.id) {
            showAlert("Status update successfully!", "success");
        } else {
            showAlert("Something went wrong!", "error");
        }
        setActiveLoader(-1);
        setAlertForStatus(false);
    }

    const checkIntegration = useCallback((value) => {
        const hasGoogle = googleClassRoomCourseMap
            .some(item => item.orgId === value.id)
        const integrations = INTEGRATION_KEYS
            .filter(([prop]) => Boolean(value[prop]))
            .map(([, name]) => name)
        if (hasGoogle) integrations.push('Google Classroom')
        return integrations.length
            ? integrations.join(', ')
            : '-'
    }, [googleClassRoomCourseMap])

    const renderDistrictTable  = (dataList) => {
        return (
            <Table stickyHeader aria-label="sticky table" style={{ width: "100%", textAlign: "center", backgroundColor: "#fff", marginTop: 20 }}>
            <TableHead>
                <TableRow>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Name</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Schools</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Teachers</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Students</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Licenses</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Licenses used</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Licenses available</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>License overused</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Integration</TableCell>
                    <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Edit</TableCell>
                    {/* <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: '600' }}>Status</TableCell> */}
                </TableRow>
            </TableHead>
            <TableBody>
                {(isEmpty(dataList)) && (
                    userloading ? <Loading size={30} /> : (
                        <TableRow key={'0'} style={{ border: 0 }}>
                            <TableCell colSpan={10} style={{ textAlign: "center" }}>No results</TableCell>
                        </TableRow>
                    )
                )}
                {(!isEmpty(dataList)) && (
                    dataList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        if(!row) return null;
                        const overusedLicenses = getOverusedLicenses(row?.licenses, row?.total_utilized);
                        return (
                            <TableRow  hover selected={currentOrg?.id==row.id}  key={row.id} style={{ '&:lastChild td, &:lastChild th': { border: 0 }, }} onClick={() => setData(row)}>
                                <TableCell style={{ textAlign: "left", cursor: 'pointer',display: 'flex', alignItems: "center" }} onClick={() => {
                                    handleCurrentOrgLoader(row)
                                    skipPageResetRef.current = true;
                                    setModal2Open(!modal2Open)
                                }}>{row?.id === enableLoader && loader &&<Loading size={20} />}{row.displayName} <ViewDemo color={BORDERCOLOR[3]}>{row.demo && "(Demo)"}</ViewDemo></TableCell>
                                <TableCell style={{ textAlign: "left", color: BORDERCOLOR[2], cursor: 'pointer' }} onClick={() => {
                                    handleCurrentOrgLoader(row,'see_schools')
                                }}>
                                    {row.no_of_schools} schools
                                </TableCell>
                                <TableCell style={{ textAlign: "left", color: BORDERCOLOR[0], cursor: 'pointer' }} onClick={() => {
                                    handleCurrentOrgLoader(row, 'see_teachers')
                                }}>
                                    {get(row, 'teacher_count', 0)}
                                </TableCell>
                                <TableCell style={{ textAlign: "left", color: BORDERCOLOR[0], cursor: 'pointer' }} onClick={() => {
                                    handleCurrentOrgLoader(row,'see_students')
                                }}>
                                    {get(row, 'student_count', 0)}
                                </TableCell>
                                <TableCell
                                    onClick={() => setLicenseUsesView({ open: true, orgId: row.id })}
                                    style={{ textAlign: "left", color: BORDERCOLOR[0], cursor: "pointer" }}
                                >
                                    {get(row, 'licenses', '0') || 0}
                                </TableCell>
                                <TableCell  onClick={() => setLicenseUsesView({ open: true, orgId: row.id })} style={{ textAlign: "left", color: BORDERCOLOR[1] ,  cursor:"pointer" }}>{row?.total_utilized ? row.total_utilized : 0}</TableCell>
                                <TableCell
                                    onClick={() => setLicenseUsesView({ open: true, orgId: row.id })}
                                    style={{ textAlign: "left", color: BORDERCOLOR[2] ,  cursor:"pointer" }}
                                >
                                    {Math.max(
                                        (parseInt(row?.licenses || '0', 10) || 0) -
                                        (parseInt(row?.total_utilized || '0', 10) || 0),
                                        0
                                    )}
                                </TableCell>
                                <TableCell
                                    onClick={() => setLicenseUsesView({ open: true, orgId: row.id })}
                                    style={{ textAlign: "left", color: overusedLicenses > 0 ? '#ff4d4f' : BORDERCOLOR[2], cursor: "pointer" }}
                                >
                                    {overusedLicenses}
                                </TableCell>
                                <TableCell style={{ textAlign: "left", color: 'rgb(200, 109, 152)' }}>{checkIntegration(row)}</TableCell>
                                <TableCell style={{ textAlign: "left", cursor: 'pointer' }} onClick={(e) => {
                                    e.stopPropagation();
                                    setData(row);
                                    skipPageResetRef.current = true;
                                    setModal2Open(true);
                                }}>
                                    <EditOutlined style={{ fontSize: 18, color: '#1890ff' }} />
                                </TableCell>
                            </TableRow>
                        )
                    })
                )}
            </TableBody>
            <TableFooter>
                <TableRow>
                    {!isEmpty(dataList.filter(d => d.active)) && <TablePagination
                        count={dataList.filter(d => d.active).length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        slotProps={{
                            actions:{
                                previousButton:{
                                    color:"secondary"
                                },
                                nextButton:{
                                    color:"secondary"
                                }
                            }
                        }}
                    />}
                </TableRow>
            </TableFooter>

        </Table>
        )
    } 

    const [archiveLoader, setArchiveLoader] = useState(false);
  
    const handleUpateArchive = async (value) => {
      try {
        setArchiveLoader(true);
        const payload = {
          ...data,
          show_archive: value,
        };  

        const result = await dispatch(
          handleUpdateOrganization(data.id, {
            ...payload,
          }),
        );

        if (result?.id) {
          const updatedDistricts = filteredDistricts.map((item) =>
            item.id === data.id ? { ...item, show_archive: value } : item,
          );
          setFilteredDistricts(updatedDistricts);
          showAlert('Status update successfully!', 'success');
          skipPageResetRef.current = false;
          setModal2Open(false);
        } else {
          showAlert('Something went wrong!', 'error');
          skipPageResetRef.current = false;
          setModal2Open(false);
        }
        setActiveLoader(-1);
        setAlertForStatus(false);
      } catch (error) {
        console.log(error);
      }
      finally {
        setArchiveLoader(false);
      }
    };
    return (
        <>
         <DistrictPreviewModal open={viewLicensusesDetail.open} onClose={()=>setLicenseUsesView({open:false,orgId:null})} orgId={viewLicensusesDetail.orgId} type={"district"} />
            <ModalSection
                open={alertForStatus}
                onClose={() => setAlertForStatus(false)}
            >
                <ModalContent>
                    Are you sure you want to {get(DistrictToActive, "active", true) ? "In-Active" : "Active"}  {get(DistrictToActive, "description", '')}
                    <ModalRow>
                        <MtButton
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setAlertForStatus(false)
                            }}
                        >
                            Cancel
                        </MtButton>
                        <MtButton
                            style={{ marginRight: '4px' }}
                            color="secondary"
                            variant="contained"
                            className={`${ActiveLoader != -1 ? "disabled-button" : ""}`}
                            onClick={() => {
                                // enableDisableUser(userToEnable.id, !userToEnable.active)
                                {DistrictStatus == 'active' ? handleActiveDistrict(DistrictToActive.id, false) : handleActiveDistrict(DistrictToActive.id, true);}
                                
                            }}
                        >
                            {ActiveLoader != -1 ? <Loading size={20} white /> : 'Yes'}
                        </MtButton>
                    </ModalRow>
                </ModalContent>
            </ModalSection>
            <CleverCourseUpdate openEditModal={openModalType == "clever"} setOpenEditModal={() => setOpenModalType(null)} selectedData={distBookMapData} />
            <SchoologyUpdateModal openEditModal={openModalType == "schoology"} setOpenEditModal={() => setOpenModalType(null)} selectedData={distBookMapData} />
            <ClasslinkCourseModal openEditModal={openModalType == "classlink"} setOpenEditModal={() => setOpenModalType(null)} selectedData={distBookMapData} />
            <CanvasCourseModal openEditModal={openModalType == "canvas"} setOpenEditModal={() => setOpenModalType(null)} selectedData={distBookMapData} />
            <GooleCourseModal openEditModal={openModalType == "google"} setOpenEditModal={() => setOpenModalType(null)} selectedData={distBGoogleookMapData} orgInfo={selectedOrg} />
            <StableWrapperMain>
                <Row style={{ marginBottom: 15, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Col>
                        <Button onClick={() => addDistict()} style={{ minHeight: 38 }} type="primary">
                            <PlusOutlined /> Add Districts
                        </Button>
                    </Col>
                    <Col>
                        <BadgeButton
                            onClick={() => setShowOverusedOnly(!showOverusedOnly)}
                            startIcon={showOverusedOnly ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                            showBadge={false}
                            size="medium"
                            className="countPreviewBtn"
                            style={{
                                backgroundColor: 'unset',
                                backgroundImage: 'linear-gradient(90deg, #2563eb 0%, #06b6d4 100%)',
                                height: 42,
                                minWidth: 160
                            }}
                        >
                            Overused Licenses
                        </BadgeButton>
                    </Col>
                </Row>
                <FilterContainer className="FilterHeading">
                    <Card
                        type="inner"
                        title="Filters"
                    // extra={<a>Clear</a>}
                    >
                        <Row>
                            <Col xs={24} lg={6} md={12} className="ColCardPadding">
                                <Card style={{ width: '100%' }}>
                                    <Select
                                        variant="filled"
                                        defaultValue="INTEGRATIONS"
                                        style={{ width: '100%', fontSize: 13 }}
                                        onChange={handleChange}
                                        options={[
                                            { value: 'all', label: 'All' },
                                            { value: 'clever', label: 'Clever' },
                                            { value: 'classlink', label: 'Classlink' },
                                            { value: 'schoology', label: 'Schoology' },
                                            { value: 'canvas', label: 'Canvas' },
                                            { value: 'google', label: 'Google classroom' }
                                        ]}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} lg={18} md={12} className="ColCardPadding">
                                <Card style={{ width: '100%' }}>
                                    <Input value={searchText} placeholder="Search District by name" bordered={false} style={{ height: '32px' }} onChange={handleSearchDistrict} />
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </FilterContainer>
                <StableWrapper>
                    <Tabs activeKey={activeTabKey} onChange={(key) => { setActiveTabKey(key);        console.log("setpage1111324234")
 setPage(0); }} style={{ backgroundColor: '#fff', marginLeft: 10 }}>
                        <TabPane tab={<div style={{ marginLeft: '10px' }}>Active District</div>} key="1">
                            {renderDistrictTable(filtData.filter(d => !d.show_archive && !d.demo))}
                        </TabPane>
                        <TabPane tab={<div style={{ marginLeft: '10px' }}>Archive District</div>} key="2">
                            {renderDistrictTable(filtData.filter(d => d.show_archive))}
                        </TabPane>
                        <TabPane tab={<div style={{ marginLeft: '10px' }}>Demo Account</div>} key="3">
                            {renderDistrictTable(filtData.filter(d => d.demo))}
                        </TabPane>
                    </Tabs>
                </StableWrapper>
            </StableWrapperMain>
            <Modal
                footer={null}
                title={get(data, 'displayName', '')}
                centered
                open={modal2Open}
                onOk={() => {
                    skipPageResetRef.current = false;
                    setModal2Open(false);
                }}
                onCancel={() => {
                    skipPageResetRef.current = false;
                    setModal2Open(false);
                }}
                width={'60%'}
                className="FilterHeading"
            >
                <ProfileContainer>
                    <Button type="primary" ghost onClick={() => addDistict('edit')} >
                        Edit Profile
                    </Button>
                    {is_schoology ? <MtButton disabled={loaderType == "schoology"} variant="contained" color="primary" startIcon={loaderType == "schoology" ? <Loading size={14} white /> : null} onClick={() => { setOpenModalType("schoology") }}>
                        Book mapping
                    </MtButton> : null}
                    {is_canvas ? <MtButton disabled={loaderType == "canvas"}  variant="contained" color="primary" startIcon={loaderType == "canvas" ? <Loading size={14} white /> : null} onClick={() => {  setOpenModalType("canvas")  }}>
                        Book mapping
                    </MtButton> : null}
                    {is_classlink ? <MtButton  disabled={loaderType == "classlink"}  variant="contained" color="primary" startIcon={loaderType == "classlink" ? <Loading size={14} white /> : null} onClick={() => {  setOpenModalType("classlink") }}>
                        Book mapping
                    </MtButton> : null}
                    {is_clever ? <MtButton  disabled={loaderType == "clever"}  variant="contained" color="primary" startIcon={loaderType == "clever" ? <Loading size={14} /> : null} onClick={() => {  setOpenModalType("clever") }}>
                        Book mapping
                    </MtButton> : null}
                    <MtButton  disabled={loaderType == "google"} style={{ marginLeft:10 }}  variant="contained" color="primary" startIcon={loaderType == "google" ? <Loading size={14} /> : null} onClick={() => {  setOpenModalType("google") }}>
                        {Object.keys(distBGoogleookMapData).length > 0 ? null : <Add />} Book mapping for google classroom
                    </MtButton> 
                    <MtButton disabled={archiveLoader} variant="contained" color="primary" startIcon={archiveLoader ? <Loading size={14} white /> : null} onClick={() => handleUpateArchive(!data?.show_archive)} >
                       {data?.show_archive ? "Unarchive" : "Archive"}
                    </MtButton>
                     <VocabAccessModal id={data?.id} type={"district"}/>
                     <Button type="primary" ghost onClick={() => {
                         const existingStates = get(data, 'standard_state', []);
                         const existingCodes = existingStates?.map(s => s.code) || [];
                         setSelectedStandardStates(existingCodes);
                         setStandardStateModalOpen(true);
                     }}>
                         Set Standard State
                     </Button>
                </ProfileContainer>
                <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="Detail View"
                >
                    <Row>
                        <Col xs={24} lg={12}>
                            <OverViewContainer>
                                <OverViewLabel>Districts Name</OverViewLabel>
                                <OverViewValue>{get(data, 'displayName', '-')}</OverViewValue>
                            </OverViewContainer>
                            <OverViewContainer>
                                <OverViewLabel>Licenses</OverViewLabel>
                                <OverViewValue>{get(data, 'licenses', '0')}</OverViewValue>
                            </OverViewContainer>

                            <OverViewContainer>
                                <OverViewLabel>Licenses available</OverViewLabel>
                                <OverViewValue>
                                    {Math.max(
                                        (parseInt(get(data, 'licenses', '0'), 10) || 0) -
                                        (parseInt(get(data, 'total_utilized', '0'), 10) || 0),
                                        0
                                    )}
                                </OverViewValue>
                            </OverViewContainer>
                        </Col>
                        <Col xs={24} lg={12}>
                            <OverViewContainer>
                                <OverViewLabel>Licenses used</OverViewLabel>
                                <OverViewValue>{(get(data, 'total_utilized','0') )}</OverViewValue>
                            </OverViewContainer>
                            <OverViewContainer>
                                <OverViewLabel>Integration</OverViewLabel>
                                <OverViewValue style={{ color: 'rgb(200, 109, 152)' }}>{checkIntegration(data)}</OverViewValue>
                            </OverViewContainer>
                            <OverViewContainer>
                                <OverViewLabel style={{ color: '#ff4d4f' }}>Overused licenses</OverViewLabel>
                                <OverViewValue style={{ color: '#ff4d4f' }}>
                                    {getOverusedLicenses(get(data, 'licenses', '0'), get(data, 'total_utilized', '0'))}
                                </OverViewValue>
                            </OverViewContainer>
                            {data?.startDate && (
                                <OverViewContainer>
                                    <OverViewLabel>Start Date</OverViewLabel>
                                    <OverViewValue>{get(data, 'startDate', '')}</OverViewValue>
                                </OverViewContainer>
                            )}
                            <OverViewContainer>
                                <OverViewLabel style={{marginBottom : "10px"}}>Standard States</OverViewLabel>
                                <OverViewValue>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                        {(() => {
                                            const enabledStates = data?.standard_state?.filter(s => s.enabled) || [];
                                            
                                            return enabledStates.map((state, idx) => (
                                                <span 
                                                    key={idx}
                                                    style={{
                                                        padding: '4px 8px',
                                                        backgroundColor: '#e6f7ff',
                                                        border: '1px solid #91d5ff',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        color: '#1890ff'
                                                    }}
                                                >
                                                    {state.code === 'COMMONCORE' ? 'Common Core' : state.state}
                                                </span>
                                            ));
                                        })()}
                                    </div>
                                </OverViewValue>
                            </OverViewContainer>
                        </Col>
                    </Row>
                    <Divider />
                    <Row>
                        <Col xs={12} lg={8}>
                            <OverViewContainer>
                                <OverViewLabel>Schools</OverViewLabel>
                                <OverViewValue style={{ color: 'rgb(20, 100, 255)', cursor: 'pointer' }} onClick={() => {
                                    handleCurrentOrgLoader(data,'see_schools')
                                    skipPageResetRef.current = false;
                                    setModal2Open(false)
                                }}>
                                    {get(data, 'no_of_schools', '-')}

                                </OverViewValue>
                            </OverViewContainer>
                        </Col>
                        <Col xs={12} lg={8}>
                            <OverViewContainer>
                                <OverViewLabel>Teachers</OverViewLabel>
                                <OverViewValue style={{ color: 'rgb(20, 100, 255)', cursor: 'pointer' }} onClick={() => {
                                    handleCurrentOrgLoader(data,'see_teachers')
                                    skipPageResetRef.current = false;
                                    setModal2Open(false)
                                }
                                }>
                                    {get(data, 'teacher_count', '-')}

                                </OverViewValue>
                            </OverViewContainer>
                        </Col>
                        <Col xs={12} lg={8}>
                            <OverViewContainer>
                                <OverViewLabel>Students</OverViewLabel>
                                <OverViewValue style={{ color: 'rgb(20, 100, 255)', cursor: 'pointer' }} onClick={() => {
                                    handleCurrentOrgLoader(data,'see_students');
                                    onTabsJump("see_students", data)
                                    skipPageResetRef.current = false;
                                    setModal2Open(false)
                                }}>

                                    {get(data, 'student_count', '-')}
                                </OverViewValue>
                            </OverViewContainer>
                        </Col>
                    </Row>
                </Card>
            </Modal>
            <Modal
                title="Set Standard State"
                open={standardStateModalOpen}
                onOk={async () => {
                    if (!data?.id) {
                        showAlert("Organization ID is missing", "error");
                        return;
                    }
                    setSavingStandardState(true);
                    try {
                        const statesToSave = [...selectedStandardStates];
                        const standardStatePayload = STANDARD_GRADE_LEVEL
                            .filter(standard => statesToSave.includes(standard.code))
                            .map(standard => ({
                                state: standard.state,
                                code: standard.code,
                                enabled: true
                            }));
                        
                        const response = await apis.put('orgPermissions', '/orgPermissions/update_standard_state', {
                            body: {
                                id: data.id,
                                standard_state: standardStatePayload
                            }
                        });
                        
                        if (response && response.id) {
                            const updatedData = { ...data, standard_state: response.standard_state };
                            setData(updatedData);
                            // Update the districts lists so modal shows updated data when reopened
                            const updatedIntegrationFilter = integrationFilter.map((item) =>
                                item.id === data.id ? { ...item, standard_state: response.standard_state } : item
                            );
                            setIntegrationFilter(updatedIntegrationFilter);
                            const updatedDistricts = filteredDistricts.map((item) =>
                                item.id === data.id ? { ...item, standard_state: response.standard_state } : item
                            );
                            setFilteredDistricts(updatedDistricts);
                            showAlert("Standard states updated successfully!", "success");
                            setStandardStateModalOpen(false);
                        } else {
                            showAlert("Failed to update standard states", "error");
                        }
                    } catch (error) {
                        showAlert("Error updating standard states", "error");
                        console.error(error);
                    } finally {
                        setSavingStandardState(false);
                    }
                }}
                onCancel={() => setStandardStateModalOpen(false)}
                confirmLoading={savingStandardState}
                width={600}
            >
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Select Standard States:</label>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Select standard states"
                        value={selectedStandardStates}
                        onChange={(values) => {
                            setSelectedStandardStates(values);
                        }}
                        options={STANDARD_GRADE_LEVEL.map(standard => ({
                            label: formatStateNameForDisplay(standard.code),
                            value: standard.code
                        }))}
                        maxTagCount={undefined}
                        dropdownStyle={{ maxHeight: '300px', overflowY: 'auto' }}
                        listHeight={300}
                    />
                </div>
            </Modal>
        </>
    );
};



export default DistrictTable;
